import React from 'react';
import { WHY_STORM } from './summerCampContent';
export function SummerCampWhyParents() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3357">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3358">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3359">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3360">
            Why Parents Choose Storm Summer Camp
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3361">
          {WHY_STORM.map((reason, idx) => <div key={idx} className="bg-off-white p-8 rounded-2xl border border-subtle-gray hover:shadow-lg transition-all" data-id="element-3362">
              <reason.icon className="w-10 h-10 text-storm-red mb-4" data-id="element-3363" />
              <h3 className="text-2xl text-ink mb-3" data-id="element-3364">{reason.title}</h3>
              <p className="text-gray-warm leading-relaxed" data-id="element-3365">{reason.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}